import { DataTableCard } from '@/components/tables/DataTable/DataTableCard';
import { useRequiredParam } from '@/hooks/useRequiredParam';
import { DocumentsTable } from '@/modules/documents/DocumentsTable/DocumentsTable';
import { useClientDocumentsPageContext } from '@/pages/ClientPages/ClientDocumentsPage';

export function ClientDetailsDocumentsPage() {
  const householdId = useRequiredParam('householdId');
  const { modalOpen, setModalOpen } = useClientDocumentsPageContext();

  return (
    <DataTableCard
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
      }}
    >
      <DocumentsTable
        householdId={householdId}
        handleCreateDocumentModalClose={() => setModalOpen(false)}
        createDocumentModalOpen={modalOpen}
        documentsLike={{
          hasHouseholdWith: [
            {
              id: householdId,
            },
          ],
        }}
        variant="household-documents"
        emptyStateFill="flex"
      />
    </DataTableCard>
  );
}
